import './IconWeather.scss';
import * as React from 'react';

type Props = {
    readonly icon: string;
};

export function IconWeather({ icon }: Props): JSX.Element {
    return (
        <div className={`lvo-icon-weather lvo-icon-weather--${icon}`}/>
    );
}
